const apiVersion = 'v1';
const apiBaseUrl = process.env.NMSW_DATA_API_BASE_URL || 'http://localhost:5000';

// eslint-disable-next-line import/prefer-default-export
export const apiUrl = `${apiBaseUrl}/${apiVersion}`;
export const gaToken = process.env.GA_TOKEN;

const isEnabled = (value) =>
  typeof value === 'string' ? value.toLowerCase() === 'true' : value === true;

// Flags for showing site maintenance and notifications
export const showSiteMaintenance = isEnabled(process.env.NMSW_MAINTENANCE);
export const siteMaintenanceText = process.env.NMSW_MAINTENANCE_TEXT || '';

export const showNotification = isEnabled(process.env.NMSW_NOTIFICATION);
export const notificationText = process.env.NMSW_NOTIFICATION_TEXT || '';

export const RESTRICTED_EMAIL_PATTERNS = process.env.RESTRICTED_EMAIL_PATTERNS ?? ['gov.uk', 'police.uk'];
